export default __webpack_public_path__ + "db7a9167900106b17cd864ba1a605823.png";